import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../css/Ingresos.css';  // Archivo CSS específico para la página de Ingresos
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ROLES } from '../lib/permissions';

function Ingresos() {
  const [nombres, setNombre] = useState('');
  const [apellidos, setApellido] = useState('');
  const [cedula, setCedula] = useState('');
  const [id_tipoIdentificacion, setid_tipoIdentificacion] = useState('');
  const [fechaIngreso, setFechaIngreso] = useState('');
  const [concepto, setConcepto] = useState('');
  const [valor, setValor] = useState('');
  const [tiposIdentificacion, setTiposIdentificacion] = useState([]);
  const [conceptos, setConceptos] = useState([]);
  const [mostrarCampos, setMostrarCampos] = useState(false);  // Controla la visibilidad de los campos
  const [modoEdicion, setModoEdicion] = useState(false); // Controla si los campos son solo lectura
  const [isFormValid, setIsFormValid] = useState(false); // Estado para habilitar el botón de enviar

  const apiUrl = process.env.REACT_APP_API_URL;

  // Llamada a la API para obtener los tipos de identificación y conceptos
  useEffect(() => {
    const fetchTiposIdentificacion = async () => {
      try {
        const response = await axios.get(`${apiUrl}/Donantes/TiposIdentificacion`);
        setTiposIdentificacion(response.data);
      } catch (error) {
        toast.error('No se pudieron cargar los tipos de identificación.');
      }
    };

    const fetchConceptos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/Donantes/Conceptos/Ingresos`);
        setConceptos(response.data);
      } catch (error) {
        toast.error('No se pudieron cargar los conceptos.');
      }
    };

    fetchTiposIdentificacion();
    fetchConceptos();
  }, [apiUrl]);

  // Validar si todos los campos requeridos están completos
  useEffect(() => {
    const validarFormulario = () => {
      if (
        nombres.trim() &&
        apellidos.trim() &&
        cedula.trim() &&
        id_tipoIdentificacion &&
        fechaIngreso &&
        concepto &&
        valor > 0
      ) {
        setIsFormValid(true);
      } else {
        setIsFormValid(false);
      }
    };

    validarFormulario();
  }, [nombres, apellidos, cedula, id_tipoIdentificacion, fechaIngreso, concepto, valor]);

  // Función para manejar la consulta de datos
  const consultarDatos = async () => {
    try {
      const response = await axios.get(`${apiUrl}/Donantes/identificacion/${cedula}`);
      if (response.data) {
        setNombre(response.data.nombres);
        setApellido(response.data.apellidos);
        setid_tipoIdentificacion(response.data.id_tipoIdentificacion);
        setModoEdicion(true);  // Activa el modo solo lectura para los campos
      } else {
        setModoEdicion(false);  // Si no hay datos, los campos son editables
        setNombre('');
        setApellido('');
      }
      setMostrarCampos(true);  // Muestra los demás campos después de la consulta
    } catch (error) {
      toast.info('Usuario no registrado en la Base de Datos');
      setMostrarCampos(true);  // Aun si falla la consulta, mostrar los campos para permitir el registro
    }
  };

  // Función para manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log('=== 🚀 INICIANDO ENVÍO DE INGRESO ===');
    console.log('Datos del formulario:', {
      nombres,
      apellidos,
      cedula,
      id_tipoIdentificacion,
      fechaIngreso,
      concepto,
      valor,
      modoEdicion
    });
    
    try {
      let idDonante = cedula; // Valor por defecto en caso de fallo de consulta

      if (!modoEdicion) {
        console.log('📝 Registrando nuevo donante...');
        // Registrar el donante
        const donanteData = {
          id_tipoIdentificacion,
          nombres,
          apellidos,
          Identificacion: cedula,
          id_Rol: ROLES.DONANTE
        };
        console.log('Datos del donante a enviar:', donanteData);
        
        const donanteResponse = await axios.post(`${apiUrl}/Donantes/Donante`, donanteData);
        console.log('✅ Donante registrado:', donanteResponse.data);
        
        idDonante = donanteResponse.data.id;
        if (donanteResponse.status !== 201) {
          toast.error('Error al registrar el donante.');
          return;
        }
      } else {
        console.log('🔍 Obteniendo ID del donante existente...');
        // Si está en modo edición, obtener el IdDonante de la consulta
        const response = await axios.get(`${apiUrl}/Donantes/identificacion/${cedula}`);
        console.log('Respuesta de consulta donante:', response.data);
        
        if (response.data) {
          idDonante = response.data.id; // Utiliza el IdDonante obtenido de la respuesta
          console.log(`✅ ID Donante obtenido: ${idDonante}`);
        } else {
          toast.error('Donante no encontrado.');
          return;
        }
      }

      console.log('💰 Registrando donación...');
      
      // Obtener el ID del usuario registrante
      let userId = sessionStorage.getItem('userId');
      if (!userId) {
        // Intentar obtener desde localStorage (UserContext)
        const currentUser = localStorage.getItem('currentUser');
        if (currentUser) {
          const user = JSON.parse(currentUser);
          userId = user.id;
          console.log('✅ ID de usuario obtenido desde localStorage:', userId);
        }
      }
      
      console.log('🔍 ID Registrante:', userId);
      
      if (!userId) {
        toast.error('No se pudo identificar el usuario registrante. Por favor, inicie sesión nuevamente.');
        return;
      }
      
      // Registrar la donación
      const donacionData = {
        id_Donante: parseInt(idDonante),
        fecha_Ingreso: fechaIngreso,
        fecha_Registro: new Date().toISOString(),
        id_Concepto: parseInt(concepto),
        Valor: parseFloat(valor),
        id_Registrante: parseInt(userId)
      };
      console.log('Datos de la donación a enviar:', donacionData);
      
      const donacionResponse = await axios.post(`${apiUrl}/Donantes/Donacion`, donacionData);
      console.log('✅ Donación registrada:', donacionResponse.data);

      toast.success('Ingreso registrado exitosamente');
      setNombre('');
      setApellido('');
      setCedula('');
      setid_tipoIdentificacion('');
      setFechaIngreso('');
      setConcepto('');
      setValor('');
      setMostrarCampos(false);
    } catch (error) {
      console.error('❌ ERROR al enviar datos:', {
        status: error?.response?.status,
        data: error?.response?.data,
        message: error?.message
      });
      
      const errorMsg = error?.response?.data?.message || error?.response?.data || error?.message || 'Error desconocido';
      toast.error(`Error al enviar los datos: ${JSON.stringify(errorMsg)}`);
    }
  };


  const handleGoBack = () => {
    // Redirigir a la página de Ofrendas
    window.location.href = '/opciones';
  };

  return (
    <div className="ingresos-container">
      <h1 className="ingresos-title">Formulario de Ingresos</h1>
      <form onSubmit={handleSubmit} className="ingresos-form">
        <label htmlFor="cedula">Identificación:</label>
        <input
          type="text"
          id="cedula"
          value={cedula}
          onChange={(e) => setCedula(e.target.value)}
          required
        />
        <button type="button" onClick={consultarDatos} className="submit-button-Consulta">
          Consultar
        </button>

        {mostrarCampos && (
          <>
            <label htmlFor="nombres">Nombre:</label>
            <input
              type="text"
              id="nombres"
              value={nombres}
              onChange={(e) => setNombre(e.target.value)}
              required
              readOnly={modoEdicion}
            />

            <label htmlFor="apellidos">Apellido:</label>
            <input
              type="text"
              id="apellidos"
              value={apellidos}
              onChange={(e) => setApellido(e.target.value)}
              required
              readOnly={modoEdicion}
            />

            <label htmlFor="id_tipoIdentificacion">Tipo de Identificación:</label>
            <select
              id="id_tipoIdentificacion"
              value={id_tipoIdentificacion}
              onChange={(e) => setid_tipoIdentificacion(e.target.value)}
              required
              disabled={modoEdicion}
            >
              <option value="">Selecciona un tipo de identificación</option>
              {tiposIdentificacion.map(tipo => (
                <option key={tipo.id} value={tipo.id}>
                  {tipo.tipo_Identificacion}
                </option>
              ))}
            </select>

            <label htmlFor="fechaIngreso">Fecha de Ingreso:</label>
            <input
              type="date"
              id="fechaIngreso"
              value={fechaIngreso}
              onChange={(e) => setFechaIngreso(e.target.value)}
              required
            />

            <label htmlFor="concepto">Concepto:</label>
            <select
              id="concepto"
              value={concepto}
              onChange={(e) => setConcepto(e.target.value)}
              required
            >
              <option value="">Selecciona un concepto</option>
              {conceptos.map(concepto => (
                <option key={concepto.id} value={concepto.id}>
                  {concepto.concepto}
                </option>
              ))}
            </select>

            <label htmlFor="valor">Valor:</label>
            <input
              type="number"
              id="valor"
              value={valor}
              onChange={(e) => setValor(e.target.value)}
              required
            />
          </>
        )}

        {/* Mostrar el botón Enviar solo si el formulario es válido */}
        {isFormValid && (
          <button type="submit" className="submit-button">Enviar</button>
        )}
                {/* Botón para regresar a Ofrendas */}
      
        
        <p> </p>  <button type="button" className="submit-back" onClick={handleGoBack}>
          Regresar al menú
        </button>
<p> </p><p> </p>.<p> </p>
      </form>

      <ToastContainer />
    </div>
  );
}

export default Ingresos;
